var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicadorSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EDCF90AC-5FFE-42AE-BC15-9A5C0B5A0A43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cartera-JO-Agregar-indicador",
    transform: "translate(-593.000000, -639.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9ficit-presupuestario-Copy",
    transform: "translate(501.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indicador_selected",
    transform: "translate(92.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#416DBC",
    fill: "#416DBC",
    cx: 17,
    cy: 17,
    r: 16.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#F1F3FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "10 17 15 22 26 11"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicadorSelected);
export default __webpack_public_path__ + "static/media/indicador_selected.4262e4e8.svg";
export { ForwardRef as ReactComponent };